module.exports = __webpack_public_path__ + "img/home-4.0c4c3de0.png";